module.exports = __webpack_public_path__ + "static/media/lightroom.4a62a1bd.svg";